<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body
  >
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      ref="form"
      size="medium"
    >
      <el-form-item prop="reportDate">
        <template v-slot:label>
          <div class="form-item__label">时间</div>
        </template>
        <el-input v-model="form.reportDate" size="medium" placeholder="时间" />
      </el-form-item>
      <el-form-item prop="dspId">
        <template v-slot:label>
          <div class="form-item__label">dsp名称</div>
        </template>
        <search-dsp-select v-model="form.dspId" style="width:100%" />
      </el-form-item>
      <el-form-item prop="dspSlotId">
        <template v-slot:label>
          <div class="form-item__label">dsp广告位名称</div>
        </template>
        <search-dsp-slot-select v-model="form.dspSlotId" style="width:100%"/>
      </el-form-item>
      <el-form-item prop="showSmt">
        <template v-slot:label>
          <div class="form-item__label">展示数</div>
        </template>
        <el-input
          v-model="form.showSmt"
          size="medium"
          type="number"
          placeholder="展示数"
        />
      </el-form-item>
      <el-form-item prop="clkSmt">
        <template v-slot:label>
          <div class="form-item__label">点击数</div>
        </template>
        <el-input
          v-model="form.clkSmt"
          type="number"
          size="medium"
          placeholder="点击数"
        />
      </el-form-item>
      <el-form-item prop="income">
        <template v-slot:label>
          <div class="form-item__label">收入</div>
        </template>
        <el-input v-model="form.income" type="number" placeholder="收入" />
      </el-form-item>
    </el-form>

    <div style="text-align: right">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button
        @click="submit"
        type="primary"
        size="medium"
        :loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import { addDataAuto, upDataAutov } from "@/api/manage/account/dspEnter";

const form = {
  reportDate: undefined,
  dspId: undefined,
  dspSlotId: undefined,
  showSmt: undefined,
  clkSmt: undefined,
  income: undefined,
};
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600,
    },
    data: Object,
  },
  components: {
    SearchDspSelect,
    SearchDspSlotSelect,
  },
  emits: ["submit"],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        reportDate: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        dspId: [{ required: true, message: "请输入dsp编号", trigger: "blur" }],
        dspSlotId: [
          { required: true, message: "请输入dsp广告位编号", trigger: "blur" },
        ],
        showSmt: [{ required: true, message: "请输入展示数", trigger: "blur" }],
        clkSmt: [{ required: true, message: "请输入点击数", trigger: "blur" }],
        income: [{ required: true, message: "请输入收入", trigger: "blur" }],
      },
    };
  },
  created() {},
  computed: {
    dialogTitle() {
      return (
        (this.title ? this.title : "") + (this.form.dspId ? "编辑" : "新增")
      );
    },
  },
  methods: {
    show(data) {
      this.dialogStatus = true;
      if (data) {
        this.form = Object.assign({}, data);
      }
    },
    close() {
      this.dialogStatus = false;
      this.reset();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.appId) {
            this.update(this.form);
          } else {
            this.add(this.form);
          }
        }
      });
    },
    add(form) {
      this.submitLoading = true;
      addDataAuto(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.$emit("submit");
            this.close();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    update(form) {
      this.submitLoading = true;
      upDataAutov(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("submit");
            this.close();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    reset() {
      this.form = Object.assign({}, form);
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
</style>
